import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

const LineSvg = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="#fff"><path d="M12 2C6.48 2 2 5.92 2 10.66c0 4.28 3.8 7.86 8.94 8.54.35.07.82.22.94.51.11.26.07.67.04.93l-.15.93c-.05.27-.22 1.06.93.58s6.18-3.64 8.44-6.24C22.84 14.01 22 12.4 22 10.66 22 5.92 17.52 2 12 2z"/></svg>
);
const MessengerSvg = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="#fff"><path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.2 5.42 3.15 7.2.16.15.26.35.27.57l.05 1.78c.02.56.6.93 1.11.7l1.99-.88c.17-.07.36-.09.54-.05.92.25 1.9.38 2.89.38 5.64 0 10-4.13 10-9.7S17.64 2 12 2z"/></svg>
);
const IgSvg = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="#fff"><rect x="2" y="2" width="20" height="20" rx="5" fill="none" stroke="#fff" strokeWidth="2"/><circle cx="12" cy="12" r="5" fill="none" stroke="#fff" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1.5" fill="#fff"/></svg>
);
const WebSvg = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
);

const CONVS = [
  { key: 'conv1', color: '#0084FF', Icon: MessengerSvg, platformColor: '#0084FF' },
  { key: 'conv2', color: '#06C755', Icon: LineSvg, platformColor: '#06C755' },
  { key: 'conv3', color: '#3664D1', Icon: WebSvg, platformColor: '#3664D1' },
  { key: 'conv4', color: '#E1306C', Icon: IgSvg, platformColor: '#E1306C' },
];

export const FeatureOmnichat = () => {
  const { t } = useTranslation('landing');

  return (
    <Box component="section" sx={{ py: { xs: '60px', md: '100px' }, background: '#fff', overflow: 'hidden' }}>
      <Box sx={{ maxWidth: 1440, mx: 'auto', px: { xs: '20px', md: '40px' } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '35% 62%' }, gap: '3%', alignItems: 'center' }}>
          {/* Text */}
          <Box className="omni-reveal">
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: 16, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3664D1', mb: 2 }}>
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
              {t('featureOmnichat.label')}
            </Box>
            <Typography variant="h3" sx={{ fontSize: { xs: '1.6rem', md: 'clamp(1.6rem, 3vw, 2.2rem)' }, fontWeight: 800, lineHeight: 1.3, mb: 2, letterSpacing: '-0.3px', color: '#0f1729' }}>
              {t('featureOmnichat.title')}
            </Typography>
            <Typography sx={{ fontSize: 19, color: '#374151', lineHeight: 1.8, mb: '28px' }}>
              {t('featureOmnichat.desc')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {['bullet1', 'bullet2', 'bullet3'].map((key) => (
                <Box key={key} sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <Box sx={{ width: 24, height: 24, borderRadius: '50%', background: '#3664D1', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px', fontSize: 15, fontWeight: 700, color: '#fff' }}>&#10003;</Box>
                  <Typography sx={{ fontSize: 18, color: '#374151', lineHeight: 1.5 }}>{t(`featureOmnichat.${key}`)}</Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Mockup */}
          <Box className="omni-feature-visual omni-reveal omni-reveal-delay-1">
            <Box className="omni-mockup-frame">
              <Box className="omni-mockup-chrome">
                <Box className="omni-mockup-dots"><span /><span /><span /></Box>
                <Box className="omni-mockup-title">{t('featureOmnichat.mockup.title')}</Box>
              </Box>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '220px 1fr' }, minHeight: 420 }}>
                {/* Sidebar */}
                <Box className="mock-sidebar" sx={{ display: { xs: 'none', md: 'block' } }}>
                  <Box className="mock-sidebar-tabs">
                    <span className="active">{t('featureOmnichat.mockup.tabs.all')}</span>
                    <span>{t('featureOmnichat.mockup.tabs.unread')}</span>
                  </Box>
                  <Box>
                    {CONVS.map((conv, i) => (
                      <Box key={conv.key} className={`mock-conv${i === 0 ? ' active' : ''}`}>
                        <Box className="mock-avatar" sx={{ background: conv.color }}>
                          {t(`featureOmnichat.mockup.${conv.key}.name`).charAt(0)}
                          <Box className="platform-dot" sx={{ background: conv.platformColor }}>
                            <conv.Icon />
                          </Box>
                        </Box>
                        <Box className="mock-conv-info">
                          <Box className="mock-conv-name">{t(`featureOmnichat.mockup.${conv.key}.name`)}</Box>
                          <Box className="mock-conv-msg">{t(`featureOmnichat.mockup.${conv.key}.msg`)}</Box>
                        </Box>
                        <Box className="mock-conv-time">{t(`featureOmnichat.mockup.${conv.key}.time`)}</Box>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Chat Center */}
                <Box className="mock-chat-center">
                  <Box className="mock-chat-topbar">
                    <Box className="mock-chat-topbar-left">
                      <Box className="mock-chat-topbar-name">{t('featureOmnichat.mockup.chatName')}</Box>
                      <Box className="mock-platform-badge" sx={{ background: '#0084FF' }}>{t('featureOmnichat.mockup.chatPlatform')}</Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box className="mock-status-pill" sx={{ background: '#dcfce7', color: '#166534' }}>{t('featureOmnichat.mockup.chatStatus')}</Box>
                      <Box className="mock-toggle">
                        <span className="toggle-label on">{t('featureOmnichat.mockup.toggleAi')}</span>
                        <Box className="toggle-track"><Box className="toggle-knob" /></Box>
                        <span className="toggle-label off">{t('featureOmnichat.mockup.toggleHuman')}</span>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="mock-messages">
                    <Box className="mock-bubble incoming">{t('featureOmnichat.mockup.bubble1')}</Box>
                    <Box className="mock-bubble outgoing">
                      {t('featureOmnichat.mockup.bubble2')}
                      <span className="ai-badge">AI</span>
                    </Box>
                    <Box className="mock-bubble outgoing">
                      {t('featureOmnichat.mockup.bubble3')}
                      <span className="ai-badge">AI</span>
                    </Box>
                  </Box>
                  <Box className="mock-chat-input">
                    <Box className="mock-chat-input-box">{t('featureOmnichat.mockup.inputPlaceholder')}</Box>
                    <Box className="mock-chat-send">{t('featureOmnichat.mockup.send')}</Box>
                  </Box>
                </Box>

              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
